








































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Tank, TanksApi } from '@/api';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';

@Component({
	components: {},
})
export default class TankCurrentStatus extends Vue {
	@Prop() public tankId!: number;
	@Prop() public graphId!: string;
	@Prop() public safeFill!: number;
	public tankState = {};
	public chart;

	public created() {
		this.loadCurrentState();
	}

	public async loadCurrentState() {
		try {
			const response = await new TanksApi().tanksTankIdCurrentStateGet(this.tankId, {});
			this.tankState = response.data.data;
			this.tankState = { ...this.tankState, safe: this.safeFill };
			await this.loadGauge();
		} catch (e) {
			console.log(e);
		}
	}

	public async loadGauge() {
		if (this.chart) {
			await this.chart.dispose();
		}
		this.chart = am4core.create(`currentStatus ${this.graphId}`, am4charts.GaugeChart);
		this.chart.innerRadius = -40;
		this.chart.startAngle = 135;
		this.chart.endAngle = 405;

		// Create Legend
		let labelList = new am4core.ListTemplate(new am4core.Label());
		labelList.template.isMeasured = false;
		labelList.template.background.strokeWidth = 2;
		labelList.template.fontSize = 12;
		labelList.template.padding(5, 5, 5, 5);
		labelList.template.y = am4core.percent(50);
		labelList.template.horizontalCenter = 'middle';
		let labels = [
			{ y: 62, val: `${this.tankState.percentFull}%` },
			{ y: 75, val: `${this.tankState.volume} L` },
			{ y: 88, val: `${this.$options.filters.dateTimeDiff(this.tankState.percentFullTs * 1000)}` },
		];
		labels.forEach(L => {
			if (L.val && !L.val.startsWith('undefined')) {
				let label = labelList.create();
				label.parent = this.chart.chartContainer;
				label.x = am4core.percent(50);
				label.y = am4core.percent(L.y);
				label.background.stroke = new am4core.color('#808181');
				label.background.fill = label.background.stroke;
				label.fill = new am4core.color('#FFF');
				label.text = L.val;
			}
		});

		// Create axis
		const axis = this.chart.xAxes.push(new am4charts.ValueAxis<am4charts.AxisRendererCircular>());
		axis.min = 0;
		axis.max = this.tankState.maxVolume;
		axis.strictMinMax = true;
		axis.renderer.grid.template.disabled = true;
		axis.renderer.labels.template.disabled = true;
		axis.renderer.labels.template.fontSize = 10;
		axis.renderer.labels.template.radius = 5;
		axis.renderer.grid.template.color = am4core.color('#FFF');

		const axis2 = this.chart.xAxes.push(new am4charts.ValueAxis<am4charts.AxisRendererCircular>());
		axis2.min = 0;
		axis2.max = 100;
		axis2.strictMinMax = true;
		axis2.renderer.inside = true;
		axis2.renderer.labels.template.disabled = true;
		axis2.renderer.labels.template.radius = 60;
		axis2.renderer.labels.template.fontSize = 10;
		axis2.renderer.grid.template.disabled = false;

		//Add labels
		let axis1Labels = [
			0,
			this.tankState.minVolume,
			Math.round(this.tankState.maxVolume * 0.3),
			Math.round(this.tankState.maxVolume * 0.5),
			Math.round(this.tankState.maxVolume * 0.7),
			this.tankState.safe,
			Math.round(this.tankState.maxVolume),
		];
		axis1Labels.forEach(label => {
			if (label || label === 0) {
				let axisRange = axis.axisRanges.create();
				axisRange.value = label;
				axisRange.label.text = label + ' L';
			}
		});
		let axis2Labels = [0, 20, 40, 60, 80, 100];
		axis2Labels.forEach(label => {
			let axis2Range = axis2.axisRanges.create();
			axis2Range.value = label;
			axis2Range.label.text = label + '%';
		});

		// Add button
		let button = this.chart.createChild(am4core.Button);
		button.label.text = 'i';
		button.padding(5, 10, 5, 10);
		button.align = 'right';
		button.zIndex = 4;
		button.events.on('hit', ev => {
			setTimeout(() => {
				this.chart.openModal(
					"<div style=' color:#6C757D'>&#9632;Unmeasurable Volume</div>" +
						"<div style=' color:#F6861F'>&#9632;0% - 30% </div>" +
						"<div style=' color:#002C77'>&#9632;30% - 70%</div>" +
						"<div style=' color:#17A2B8'>&#9632;70% - 100%</div>" +
						"<div style=' color:#DC3545'>&#9632;Safe Fill</div>",
				);
			}, 10);
		});

		let rangeValues = [
			{ start: 0, end: this.tankState.minVolume, color: '#6C757D' },
			{
				start: this.tankState.minVolume,
				end: this.tankState.maxVolume * 0.298,
				color: '#F6861F',
			},
			{
				start: this.tankState.maxVolume * 0.302,
				end: this.tankState.maxVolume * 0.698,
				color: '#002C77',
			},
			{
				start: this.tankState.maxVolume * 0.702,
				end: this.tankState.maxVolume,
				color: '#17A2B8',
			},
			{
				start: this.tankState.safe * 0.998,
				end: this.tankState.safe * 1.002,
				color: '#DC3545',
			},
		];

		rangeValues.forEach(value => {
			let range = axis.axisRanges.create();
			range.value = value.start;
			range.endValue = value.end;
			range.axisFill.fillOpacity = 1;
			range.axisFill.fill = am4core.color(value.color);
			range.axisFill.zIndex = value.z;
		});

		// Add hand
		const hand = this.chart.hands.push(new am4charts.ClockHand());
		hand.value = this.tankState.volume;
		hand.fill = am4core.color('#404040');
		hand.stroke = am4core.color('#FFF');
		hand.radius = am4core.percent(80);
		hand.startWidth = 10;
	}
}
